// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1f169528","239":"7242e360","453":"48863d4d","455":"170b94c2"}[chunkId] + ".chunk.js";
};